// eslint-disable-next-line 
export const floweringArchTypesEnum = Object.freeze({
  basedOnCurrent: 'basedOnCurrent',
  basedOnAdvise: 'basedOnAdvise',
});
